import {
    APP_NAME,
    APP_URL,
    API_URL,
    MIDTRANS_CLIENT_KEY,
    MIDTRANS_SCRIPT_URL,
    URL_SUPPORT_TEAM,
    FACEBOOK_PIXEL_ID,
    GOOGLE_ANALYTICS_TRACKING_CODE,
    BANNER_HOMEPAGE_URL
} from 'configuration';

const AppConsts = {
    APP_NAME: APP_NAME,
    Logos_APPURL: APP_URL,
    Logos_APIURL: API_URL,
    FACEBOOK_PIXEL_ID: FACEBOOK_PIXEL_ID,
    GOOGLE_ANALYTICS_TRACKING_CODE: GOOGLE_ANALYTICS_TRACKING_CODE,
    UrlSupportTeam: URL_SUPPORT_TEAM,
    BANNER_HOMEPAGE_URL: BANNER_HOMEPAGE_URL,
    Midtrans: {
        ClientKey: MIDTRANS_CLIENT_KEY,
        ScriptUrl: MIDTRANS_SCRIPT_URL
    }
};

export default AppConsts;